import Entity from 'utilities/Entity';

class Ambassador extends Entity {}

export default new Ambassador();
